import React, { useEffect, useState } from 'react';
import './Loader.scss';
import logoSvg from 'assets/images/logo-c-loader.svg';

const DashboardLoader = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        // Se detiene en 95% y espera a que los datos carguen
        if (prev >= 95) return 95;
        
        // Progreso adaptativo: más rápido al inicio, más lento al final
        if (prev < 60) {
          // Rápido: 0-60% en ~750ms
          return prev + 8;
        } else if (prev < 85) {
          // Medio: 60-85% en ~830ms
          return prev + 3;
        } else {
          // Lento: 85-95% en ~1000ms
          return prev + 1;
        }
      });
    }, 50);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="dashboard-loader">
      <div className="dashboard-loader__content">
        <img 
          src={logoSvg} 
          alt="Constitution Lending" 
          className="dashboard-loader__logo"
        />
        <div className="dashboard-loader__progress-bar">
          <div 
            className="dashboard-loader__progress-fill"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default DashboardLoader;

